import { render, staticRenderFns } from "./SitchPayment.vue?vue&type=template&id=d8a8b374&scoped=true&"
import script from "./SitchPayment.vue?vue&type=script&lang=ts&"
export * from "./SitchPayment.vue?vue&type=script&lang=ts&"
import style0 from "./SitchPayment.vue?vue&type=style&index=0&id=d8a8b374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a8b374",
  null
  
)

export default component.exports